import { Annotation } from "../objects/Annotation.interface";
import { Entity } from "../objects/Entity.interface";
import { Project } from "../objects/Project.interface";
import { AnnotationService } from "../services/Annotations.service";
import { EntitiesService } from "../services/Entities.service";

export class ImportData{
    entityService:EntitiesService = new EntitiesService();
    annotationService:AnnotationService = new AnnotationService();

    SaveEntities = async (entityList:Entity[], projectId:number)=>{
            
        var result = this.entityService.getList(projectId);
        await result.then(async res =>
            {
                var newEntities:Entity[] = [];
                const allEntities = res? (res as Entity[]): ([] as Entity[]); 
                const allEntitiesIds = allEntities.map((entity) => entity.Code);
                newEntities = entityList.filter((entity) => !allEntitiesIds.includes(entity.Code));
                 
                await this.entityService.addSet(newEntities);
            });
    }

    UpdateRelatedAnnotationsIds = async (docId:number) => {
        var relatedAnnotations: Annotation[] = [];

        //se obtienen las anotaciones de un documento en especifico
        await this.annotationService.getByDocumentId(docId).then(annotations => {
            relatedAnnotations = annotations.filter(item => item.relatedTo !== -1);
        });

        relatedAnnotations.forEach(item => {
            //encontrar la anotacion relacionada que no sea ella misma
            var relatedAnnotation = relatedAnnotations.find(relatedItem => relatedItem.id !== item.id && relatedItem.relatedKey === item.relatedKey);
            
            //si encuentra su anotacion relacionada se actualizan los ids
            if(relatedAnnotation !== undefined){
                item.relatedTo = relatedAnnotation.id!;
            }
        });

        if(relatedAnnotations.length > 0){
            //se guardan los cambios realizados
            await this.annotationService.updateBulk(relatedAnnotations);
        }
       
    }
}